import React from 'react'
import { LABELS } from '../constants/staticText'
import { fileUrl } from '../functions/fileUrl'
import { formatDayRange, formatOpeningTimes } from '../functions/formatDays'
import RichText from '../../lib/components/RichText'
import job4uLogo from '../../../imgs/job4u_ev_Logo.png'
import { bildMasse } from '../../lib/functions/bildMasse'

// Sidebar aus den strukturierten Feldern (Entscheidung in Spec Abschnitt 3):
// Tage, Ort, Beschreibung, danach die Initiatoren-Logos. Der Eintritt ist
// redaktioneller Sidebar-Text, kein eigenes Feld (#120). Kompakt (auf den
// Abschnittsseiten, Spec-Aenderung 2026-09-30) nur die Stammdaten: Texte und
// Initiatoren bleiben der Messeseite, damit der Abschnitt Platz hat.
//
// titleLevel: auf der Messeseite ist der Name der Messe die Hauptueberschrift
// (h1), auf einem Abschnitt gehoert die h1 dem Abschnittstitel und der Name
// steht als h2 (Audit 2026-10-07, S3). headingRef: die Messeseite gibt ihrer
// h1 nach dem Laden den Fokus (#236).
const EventSidebar = ({ event, compact = false, titleLevel = 2, headingRef = null }) => {
    if (event.sidebarHidden) return null

    const Titel = 1 === titleLevel ? 'h1' : 'h2'

    return (
        <aside className="event-sidebar">
            <div className="event-sidebar-box">
                <Titel className="event-sidebar-title" tabIndex={headingRef ? -1 : undefined} ref={headingRef}>{event.name}</Titel>
                <p className="event-sidebar-dates">
                    {formatDayRange(event.days)}<br />
                    {formatOpeningTimes(event.days)}<br />
                    {event.venue?.name}
                </p>
                {!compact && (event.sidebarTexts || []).map((text, index) => (
                    <RichText className="event-sidebar-text" key={index} html={text} />
                ))}
            </div>

            {!compact && event.organizers?.length > 0 && (
                <div className="event-sidebar-organizers">
                    <p className="event-sidebar-organizers-title">{LABELS.initiativeBy}</p>
                    <ul>
                        {event.organizers.map((organizer, index) => {
                            // Ohne eigenes Logo steht das job4u-Logo, wie es das
                            // Backoffice verspricht („leer = job4u-Logo“, #226).
                            const inhalt = organizer.logo
                                ? <img src={fileUrl(organizer.logo.fileId)} alt={organizer.name} loading="lazy" decoding="async" {...bildMasse(organizer.logo)} />
                                : <img src={job4uLogo} alt={organizer.name || 'job4u'} loading="lazy" decoding="async" />

                            return (
                                <li key={index}>
                                    {/* Die Website des Initiators kommt aus dem
                                        Backoffice (organizers[].url, #198); das Ziel
                                        liegt ausserhalb der App, darum ein
                                        gewoehnliches <a>. */}
                                    {organizer.url ? <a href={organizer.url}>{inhalt}</a> : inhalt}
                                </li>
                            )
                        })}
                    </ul>
                </div>
            )}
        </aside>
    )
}

export default EventSidebar
